import React, {useCallback, useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import {GoogleMap, Marker, InfoWindow} from '@react-google-maps/api'
import useEffectEvent from '../../hooks/use-effect-event'
import {useIntl} from 'react-intl'

export default function MapPage({locations, activeMarker}) {
    const mapRef = useRef(null)
    const intl = useIntl()

    const [selected, setSelected] = useState(activeMarker)

    const boundsToAllMarkers = useEffectEvent((map) => {
        const bounds = new window.google.maps.LatLngBounds()
        locations.forEach((loc) => bounds.extend(loc.position))
        map.fitBounds(bounds)
    })

    const onLoad = useCallback(
        (map) => {
            mapRef.current = map
            boundsToAllMarkers(map)
        },
        [boundsToAllMarkers]
    )

    useEffect(() => {
        if (mapRef.current) {
            if (activeMarker !== null) {
                mapRef.current.panTo(activeMarker.position)
                mapRef.current.setZoom(16)
                setSelected(activeMarker)
            } else {
                boundsToAllMarkers(mapRef.current)
            }
        }
    }, [activeMarker, boundsToAllMarkers])

    return (
        <Box pl={{base: 0, lg: 4}}>
            <GoogleMap
                mapContainerStyle={{width: '100%', height: '31rem'}}
                zoom={14}
                onLoad={onLoad}
            >
                {locations.map((loc, index) => {
                    return (
                        <Marker
                            key={loc.id}
                            position={loc.position}
                            onClick={() => {
                                setSelected(loc)
                            }}
                            label={{
                                text: String(index + 1),
                                color: 'white',
                                fontSize: '16px',
                                fontWeight: 'bold'
                            }}
                            title={
                                intl.formatMessage({
                                    defaultMessage: 'Store: ',
                                    id: 'store_locator.store'
                                }) + loc.name
                            }
                        ></Marker>
                    )
                })}

                {selected?.infoWindowHtml && (
                    <InfoWindow position={selected.position} onCloseClick={() => setSelected(null)}>
                        <Box dangerouslySetInnerHTML={{__html: selected.infoWindowHtml}} />
                    </InfoWindow>
                )}
            </GoogleMap>
        </Box>
    )
}

MapPage.propTypes = {
    locations: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            position: PropTypes.object.isRequired,
            infoWindowHtml: PropTypes.string
        })
    ).isRequired,
    activeMarker: PropTypes.object
}
